import MediaAboutUs from "@/src/cashback/LandingPage/MediaAboutUs";
import { CashbackABTest } from "@/src/cashback/LandingPage/_lp_ab_tests";
import { languageSelector, useUserAuthenticationContext } from "@/src/contexts";
import { allStoresCategoriesPanelId, whatIsCashbackPanelId } from "@Constants/PortalConstants";

import PanelSection from "../../shared/panel-section";
import CashbackFAQ, { type IFaqQuestionAnswers } from "../LandingPage/CashbackFAQ";
import { CashbackLandingPageResources } from "../LandingPage/CashbackLandingPage.Resources";
import { CashbackLandingPageResourcesEn } from "../LandingPage/CashbackLandingPage.Resources.En";
import type { ICashbackNumbersItem } from "../LandingPage/CashbackNumbers";
import CashbackNumbers from "../LandingPage/CashbackNumbers";
import type { ICashbackTopSection } from "../LandingPage/CashbackTopSection";
import type { IGoodieAdvantages } from "../LandingPage/GoodieAdvantages";
import GoodieAdvantages from "../LandingPage/GoodieAdvantages";
import type { IPopularCashbackBrands } from "../LandingPage/PopularCashbackBrands";
import PopularCashbackBrands from "../LandingPage/PopularCashbackBrands";
import {
    type ISecondRegistrationBanner,
    SecondRegistrationBanner,
} from "../LandingPage/SecondRegistrationBanner";
import WhatIsCashback from "../LandingPage/WhatIsCashback";

import * as css from "./CashbackLandingPageMobile.module.css";

export type ICashbackLandingPageMobile = {
    cashbackTopSection: ICashbackTopSection;
    cashbackNumbers: ICashbackNumbersItem[];
    goodieAdvantages: IGoodieAdvantages;
    faqList: IFaqQuestionAnswers[];
    secondRegistrationBanner: ISecondRegistrationBanner;
    popularCashbackBrands: IPopularCashbackBrands;
    variant: string;
};

export const CashbackLandingPageMobile = (props: ICashbackLandingPageMobile) => {
    const resources = languageSelector(CashbackLandingPageResources, CashbackLandingPageResourcesEn);
    const { isAuthenticated } = useUserAuthenticationContext();

    return (
        <div className={css.cashbackLandingPageMobileComponent}>
            <CashbackABTest variant={props.variant} />

            <PanelSection {...resources.whatIsCashback} id={whatIsCashbackPanelId}>
                <WhatIsCashback
                    videoButtonText={resources.whatIsCashback.videoTitle}
                    showVideoButton={false}
                />
            </PanelSection>

            <PanelSection {...resources.faqCashback}>
                <CashbackFAQ frequentQuestionsList={props.faqList} />
            </PanelSection>

            <PanelSection {...resources.popularCashbackBrands} id={allStoresCategoriesPanelId}>
                <PopularCashbackBrands {...props.popularCashbackBrands} />
            </PanelSection>

            <PanelSection {...resources.goodieAdvantages}>
                <GoodieAdvantages {...props.goodieAdvantages} />
            </PanelSection>

            <PanelSection>
                <CashbackNumbers numbersList={props.cashbackNumbers} />
            </PanelSection>

            <PanelSection {...resources.mediaAboutUs}>
                <MediaAboutUs />
            </PanelSection>

            {isAuthenticated ? null : (
                <SecondRegistrationBanner
                    {...props.secondRegistrationBanner}
                    {...resources.secondRegistrationBanner}
                />
            )}
        </div>
    );
};
